import { render, staticRenderFns } from "./RemainingAssetReportList.vue?vue&type=template&id=20f55eb1&scoped=true&"
import script from "./RemainingAssetReportList.vue?vue&type=script&lang=js&"
export * from "./RemainingAssetReportList.vue?vue&type=script&lang=js&"
import style0 from "./RemainingAssetReportList.vue?vue&type=style&index=0&id=20f55eb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f55eb1",
  null
  
)

export default component.exports